export const parseJwt = (token) => {
  const INDEX = 1;
  const base64 = token.split('.')[INDEX].replace('-', '+').replace('_', '/');

  return JSON.parse(window.atob(base64));
};
